import React, {useEffect, useState} from "react";
import Form from "../../lib/appfuse-react/component/Form";
import Box from "../../lib/appfuse-react/component/Box";
import Typography from "@material-ui/core/Typography";
import i18n from "../../lib/appfuse-react/core/i18n";
import {Checkbox, FormControlLabel, FormLabel, Grid, TextField} from "@material-ui/core";
import Address from "../../component/Address";
import Button from "../../lib/appfuse-react/component/Button";
import {makeStyles} from "@material-ui/core/styles";
import Tooltip from "../../component/Tooltip";
import UserEvent from "../../lib/appfuse-react/core/UserEvent";
import usePrompt from "../../lib/appfuse-react/hook/usePrompt";
import SelectField from "../../lib/appfuse-react/component/SelectField";
import registrationService from "../../service/iam/registrationService";
import settingService from "../../service/setting/settingService";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";

const STEPS = ['Confirmation Statement', 'Register Information', 'Certification Standard'];
const FORMS = [ConfirmStatement, RegisterInformation, CertificationStandard];

const useStyles = makeStyles(theme => ({
    link: {
        textDecoration: 'underline',
        textUnderlinePosition: 'under',
        cursor: 'pointer'
    },
}))

/**
 * 境內註冊
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

function DomesticRegistration(props){
    const { value, activeStep } = props;
    const domesticTitle = STEPS[activeStep - 1];
    const DomesticForms = FORMS[activeStep - 1];
    const [certificateStandard, setCertificateStandard] = useState();
    const prompt = usePrompt();

    useEffect(() => {
        (async () => {
            const data = await settingService.findCertificateStandards();
            setCertificateStandard(data);
        })()
    },[])

    const handleNext = async (data) => {
        try {
            await registrationService.domesticValidate(data);
            props.onNext();
        } catch (e) {
            prompt.alert(e, {title: 'Invalid input.'});
        }
    }

    const handleComplete = async (validateData, data) => {
        try {
             await registrationService.domesticValidate(validateData);

             await registrationService.domesticPost(data);

             props.onComplete();
        } catch (e) {
            prompt.alert(e, {title: 'Registration failed.'});
        }
    }

    return <DomesticForms value={value} onChange={props.onChange} title={domesticTitle} certificateStandard={certificateStandard}
                          onNext={handleNext} onBack={props.onBack} onComplete={handleComplete}   />
}

// 確認聲明
function ConfirmStatement(props){
    const {value, title} = props;
    const statements = ConfirmationStatements;
    const validateData = {confirmStatement: value?.confirmStatement || false};

    const handleNext = () => props.onNext(validateData);

    return (
        <Form value={value} onChange={props.onChange} fullWidth fullHeight display="flex" flexDirection="column" overflow="hidden">
            <Box display="flex" paddingTop={1} paddingBottom={2} fullWidth>
                <Typography variant="h5">{i18n.translate(title)}</Typography>
            </Box>
            <Box display="flex" flexDirection="column" gap={2} paddingTop={2} paddingBottom={2} fullWidth fullHeight overflow="auto">
                { statements.map(statement => <Typography>{statement}</Typography>) }
                <Box paddingLeft={2} width="20%">
                    <FormControlLabel
                        control={<Checkbox/>}
                        name="confirmStatement"
                        label="I agree"
                    />
                </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" paddingTop={2} fullWidth>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Next" variant="contained" color="primary" onClick={handleNext}/>
            </Box>
        </Form>
    )
}

//註冊資訊
function RegisterInformation(props) {
    const { value, title } = props;

    const validateData = {
        applicant: value?.applicant || null,
        personInCharge: value?.personInCharge || null,
        idNo: value?.idNo || null,
        contactPerson: value?.contactPerson || null,
        contactPhone1: value?.contactPhone1 || null,
        contactPhone2: value?.contactPhone2 || null,
        fax: value?.fax || null,
        email: value?.email || null,
        mailingAddress: value?.mailingAddress || null,
        permanentAddress: value?.permanentAddress || null
    };

    const handleChecked = event => {
        const address = event.target.checked? (value?.permanentAddress || null) : value?.mailingAddress;
        const newValue = {...value, sameAsPermanent: event.target.checked, mailingAddress: address};
        props.onChange(new UserEvent({value: newValue}));
    }

    const handleNext = () => props.onNext(validateData);

    return (
        <Form value={value} onChange={props.onChange} fullWidth fullHeight display="flex" flexDirection="column" overflow="hidden">
            <Box display="flex" paddingTop={1} paddingBottom={2} fullWidth>
                <Typography variant="h5">{i18n.translate(title)}</Typography>
            </Box>
            <Box fullWidth fullHeight overflow="auto" paddingTop={1}>
                <Grid container spacing={2} xs={12}>
                    {/*申請者名稱*/}
                    <Grid item xs={4}>
                        <TextField name="applicant" label="Applicant" variant="outlined" fullWidth required
                                   helperText="If you are individual registration, please filled in applicant name..." />
                    </Grid>
                    {/*負責人*/}
                    <Grid item xs={4}>
                        <TextField name="personInCharge" label="Legal Representative" variant="outlined" fullWidth required
                                   helperText="If you are individual registration, please filled the same as applicant name..." />
                    </Grid>
                    {/*身分證字號(統一編號)*/}
                    <Grid item xs={4}>
                        <TextField name="idNo" label="ID Number" variant="outlined"
                                   fullWidth required helperText="Id number will be your account number"/>
                    </Grid>
                    {/*聯絡人*/}
                    <Grid item xs={4}>
                        <TextField name="contactPerson" label="Contact person" variant="outlined"
                                   fullWidth required/>
                    </Grid>
                    {/*聯絡電話1*/}
                    <Grid item xs={4}>
                        <TextField name="contactPhone1" label="Contact phone 1" variant="outlined"
                                   fullWidth helperText="Please enter only digits(e.g., 0277146060, 0912345678)" required/>
                    </Grid>
                    {/*聯絡電話2*/}
                    <Grid item xs={4}>
                        <TextField name="contactPhone2" label="Contact phone 2" variant="outlined"
                                   fullWidth/>
                    </Grid>
                    {/*傳真電話*/}
                    <Grid item xs={4}>
                        <TextField name="fax" label="Fax" variant="outlined"
                                   fullWidth />
                    </Grid>
                    {/*電子郵件*/}
                    <Grid item xs={4}>
                        <TextField name="email" label="Email" variant="outlined"
                                   fullWidth required/>
                    </Grid>
                    {/*戶籍/公司登記地址*/}
                    <Grid item xs={12}>
                        <Box display="flex" flexDirection="column" gap={1}>
                            <FormLabel>{i18n.translate("Company registered address")}</FormLabel>
                            <Address name="permanentAddress"/>
                        </Box>
                    </Grid>
                    {/*通訊地址*/}
                    <Grid item xs={12}>
                        <Box display="flex" flexDirection="column">
                            <Box display="flex" alignItems="center" gap={2}>
                                <FormLabel required>{i18n.translate("Mailing address")}</FormLabel>
                                <FormControlLabel
                                    control={<Checkbox checked={value?.sameAsPermanent || false} onChange={handleChecked}/>}
                                    label="Same as company registered address"
                                />
                            </Box>
                            <Address name="mailingAddress"/>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box display="flex" justifyContent="space-between" paddingTop={2} fullWidth>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Next" variant="contained" color="primary" onClick={handleNext}/>
            </Box>
        </Form>
    )
}

// 驗證標準
function CertificationStandard(props) {
    const { value, title, certificateStandard } = props;

    const validateData = {
        twStandard: value?.twStandard || null,
        twCategories: value?.twCategories || [],
        usStandard: value?.usStandard || null,
        usCategories: value?.usCategories || [],
        euStandard: value?.euStandard || null,
        euCategories: value?.euCategories || [],
        mainProductItem: value?.mainProductItem || null
    };

    return (
        <Form value={value} onChange={props.onChange} display="flex" flexDirection="column" fullWidth fullHeight overflow="hidden">
            <Box paddingTop={1} paddingBottom={2} fullWidth>
                <Typography variant="h5">{i18n.translate(title)}</Typography>
            </Box>
            <Box display="flex" flexDirection="column" gap={2} fullWidth fullHeight paddingTop={1} overflow="auto">
                {/*驗證標準類別*/}
                <CertificationStandardControl value={value} onChange={props.onChange} certificateStandard={certificateStandard}/>
                {/*主要生產品項*/}
                <Box fullWidth marginBottom={1}>
                    <TextField name="mainProductItem" label="Main product items" variant="outlined" multiline
                               placeholder={i18n.translate("Please enter items")} fullWidth required/>
                </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" paddingTop={2} fullWidth>
                <Button text="Back" color="secondary" onClick={props.onBack} />
                <Button text="Complete" variant="contained" color="primary" onClick={() => props.onComplete(validateData, value)}/>
            </Box>
        </Form>
    )
}

function CertificationStandardControl(props){
    const classes = useStyles();
    const { value, certificateStandard } = props;
    const twCategories = certificateStandard.find(item => item.code === "TW")?.categories || [];
    const nopCategories = certificateStandard.find(item => item.code === "US")?.categories || [];
    const euCategories = certificateStandard.find(item => item.code === "EU")?.categories || [];

    return (
        <Form value={value} onChange={props.onChange} fullWidth>
            <Box display="flex" flexDirection="column" gap={2} fullWidth fullHeight>
                {/*台灣標準*/}
                <Box display="flex"  fullWidth fullHeight>
                    <FormControlLabel
                        control={<Checkbox/>}
                        name="twStandard"
                        label="Taiwan"
                    />
                    <Box flexGrow={1}>
                        { value?.twStandard &&
                            <SelectField name="twCategories" label="Certification category" variant="outlined" fullWidth multiple options={twCategories}
                                         valueAccessor="code" textAccessor="name"/>
                        }
                    </Box>
                </Box>
                <Box paddingLeft={4} width="20%" fullHeight>
                    <Tooltip
                        title={<TaiwanStandardDescription/>}
                        placement="right-start"
                        backgroundColor="white"
                        boxShadow={5}
                        padding={2}
                        maxWidth="40rem"
                        maxHeight="20rem"
                        overflow="auto"
                        borderRadius="1rem"
                    >
                        <Typography variant="subtitle1" className={classes.link} noWrap>{i18n.translate("Taiwan standard description")}</Typography>
                    </Tooltip>
                </Box>
                {/*美國標準*/}
                <Box display="flex">
                    <FormControlLabel
                        control={<Checkbox/>}
                        name="usStandard"
                        label="United State"
                    />
                    <Box flexGrow={1}>
                        { value?.usStandard &&
                            <SelectField name="usCategories" label="Certification category" variant="outlined" fullWidth multiple options={nopCategories}
                                         valueAccessor="code" textAccessor="name"/>
                        }
                    </Box>
                </Box>
                {/*歐盟標準*/}
                <Box display="flex">
                    <FormControlLabel
                        control={<Checkbox/>}
                        name="euStandard"
                        label="European Union"
                    />
                    <Box flexGrow={1}>
                        { value?.euStandard &&
                            <SelectField name="euCategories" label="Certification category" variant="outlined" fullWidth multiple options={euCategories}
                                         valueAccessor="code" textAccessor="name"/>
                        }
                    </Box>
                </Box>
            </Box>
        </Form>
    )
}

function TaiwanStandardDescription(props){
    const standards = TaiwanStandardDescriptions;

    const taiwanStandardsDescription = standards.map((standard,index) => (
        <Box display="flex" flexDirection="column" paddingY={1} key={index}>
            <Typography color="primary" >{`${standard.title}`}</Typography>
            <Typography color="textSecondary" >{standard.description}</Typography>
            {standard?.subtitle && <Typography color="textSecondary" >{`(${standard?.subtitle}): ${standard?.subDescription}`}</Typography>}
        </Box>
    ))

    return (
        <Box height="100%" width="100%" gap={1}>
            {taiwanStandardsDescription}
        </Box>

    )
}

export function DomesticStepper(props) {
    const { activeStep } = props;
    const step = activeStep-1;

    return (
        <Stepper activeStep={step} orientation="vertical">
            { STEPS.map((label) => (
                <Step key={label}>
                    <StepLabel><Typography>{i18n.translate(label)}</Typography></StepLabel>
                </Step>
            ))}
        </Stepper>
    );
}

const ConfirmationStatements = [
    "慈心有機驗證股份有限公司在此聲明絕不會提供、交換、出租或出售任何所登錄之資料給其他個人、 團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。",
    "本人/本公司確認此處提供之資料屬實，並同意所提供之基本資料供慈心有機驗證股份有限公司，作為審查申請有機驗證之用。"
];

const TaiwanStandardDescriptions = [
    {
        title: "作物",
        description: "指農田裡生長的可食用作物",
        subtitle: "含自產農產加工品",
        subDescription: "指農民以自產有機農產品為原料，進行簡單乾燥、日曬、風乾、殺菁、焙炒、碾製、磨粉、脫殼、簡易分切等處理（調理）作業，且加工過程未使用食品添加物之農產加工品，如蔬果乾、乾香菇、乾金針、乾木耳、冬瓜分切等。"
    },
    {
        title: "加工",
        description: "對有機原料進行加熱、乾燥、燻製、混合、研磨、製錠、攪拌、分離、蒸餾、抽出、發酵、醃漬、脫水、脫殼、碾製、冷凍或其他足以改變原產品理化性質或具實質轉型之製造程序"
    },
    {
        title: "分裝",
        description: "對有機原料進行選別、洗淨、分切等作業，其過程不應改變原產品之理化性質"
    },
    {
        title: "流通",
        description: "改變有機農產品及有機轉型期農產品之原包裝或原標示，致影響農產品有機完整性之過程"
    },
    {
        title: "流通(自有品牌Private Label)",
        description: "委託農產品經營者生產、加工、分裝、流通有機或有機轉型期農產品，並以委託人或定作人為有機農業促進法第十八條第一項第三款所定農產品經營者之標示"
    },
];

export default DomesticRegistration